import React from 'react'
import { number, string } from 'prop-types'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'

import { ResponsiveContainer, PieChart, Pie, Label, Cell } from 'recharts'

import config from 'config'

const { assets_url: assetsUrl } = config

const FacultyRegistrationStats = ({
  acceptedCount,
  admissionRate,
  applicantCount,
  admissionSource,
}) => {
  const dataSet = [
    {
      label: 'Pendaftar',
      value: applicantCount,
      color: '#0056b3',
    },
    {
      label: 'Diterima',
      value: acceptedCount,
      color: '#0fc3c4',
    },
  ]

  return (
    <div className="faculty-regstats">
      <SectionContainer
        paddingTop={80}
        paddingBottom={120}
        marginTop={120}
        backgroundColor="#f6f7fa"
        className="faculty-regstats__section-wrapper"
      >
        <Container>
          <SectionTitle title="Rasio Pendaftaran" />
          <Row>
            <Col md="6">
              <div className="faculty-regstats__chart-wrapper">
                <ResponsiveContainer>
                  <PieChart>
                    <Pie
                      data={dataSet}
                      innerRadius="80%"
                      outerRadius="80%"
                      dataKey="value"
                    >
                      <Label value={`${admissionRate}%`} position="center" />
                      {
                        dataSet.map((d, idx) => (
                          <Cell fill={d.color} stroke={d.color} key={`cell-k-${idx}`} />
                        ))
                      }
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </Col>
            <Col md="6">
              <div className="faculty-regstats__legends">
                {
                  dataSet.map((d, idx) => (
                    <div className="faculty-regstats__legend-item" key={`stat-lgnd-${idx}`}>
                      <span className="faculty-regstats__legend-color" style={{ backgroundColor: d.color }}/>
                      <Typography component="span" variant="body" className="faculty-regstats__legend-text">
                        {`${d.label}: ${d.value}`}
                      </Typography>
                    </div>
                  ))
                }
                {
                  admissionSource &&
                  <div className="faculty-regstats__source">
                    <Typography component="p" variant="subbody" className="faculty-regstats__source-heading">
                      Sumber:
                    </Typography>
                    <Typography component="p" variant="subbody" className="faculty-regstats__source-url">
                      { admissionSource }
                    </Typography>
                  </div>
                }
              </div>
            </Col>
          </Row>
        </Container>
      </SectionContainer>
      <style jsx>
        {`
          .faculty-regstats {
            &__chart-wrapper {
              width: 100%;
              height: 360px;
              display: flex;
              align-item: center;
              justify-content: center;
              :global(.recharts-sector) {
                stroke-linejoin: round;
                stroke-width: 52px;
                @media screen and (min-width: 768px) {
                  stroke-width: 72px;
                }
                @media screen and (min-width: 992px) {
                  stroke-width: 80px;
                }
              }
              :global(.recharts-text) {
                font-family: inherit;
                font-size: 48px;
                font-weight: bold;
                color: #0c2846;
              }
            }
            &__legends {
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
            }
            &__legend-item {
              display: flex;
              align-items: center;
              margin-bottom: 1.5em;
            }
            &__legend-color {
              width: 32px;
              height: 32px;
              display: inline-block;
              border-radius: 100%;
              margin-right: 16px;
            }
            :global(&__section-wrapper) {
              background-image: url('${assetsUrl}/assets/img/polka_bg.svg'), url('${assetsUrl}/assets/img/oval.svg');
              background-position: bottom left, top right 20%;
              background-repeat: no-repeat;
              background-size: 30%;
            }
            :global(&__legend-text) {
              font-weight: bold;
              color: #0c2846;
            }
            :global(&__source-heading) {
              color: #0c2846 !important;
              font-weight: bold;
            }
            :global(&__source-url) {
              color: #0c2846 !important;
            }
          }
        `}
      </style>
    </div>
  )
}

FacultyRegistrationStats.propTypes = {
  acceptedCount: number,
  admissionRate: number,
  applicantCount: number,
  admissionSource: string,
}

export default FacultyRegistrationStats
